import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
const contentBox = "_contentBox_1xvbe_1";
const style0 = {
  contentBox
};
const __default__ = {
  name: "ContentBox",
  inheritAttrs: true
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  setup(__props) {
    return { __sfc: true };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { class: _vm.$style.contentBox }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const ContentBox = __component__.exports;
export {
  ContentBox as default
};
